import {useMemo} from 'react'
import {Helmet} from 'react-helmet'
import {useOutletContext} from 'react-router-dom'
import {useTranslation} from '@/translations/i18n'
import {MedicalRecordEmptyState} from '@/features/medical-records/components/medical-record-empty-state/MedicalRecordEmptyState'
import {usePermissions} from '@/features/auth/store/store'
import {NoPermissionBox} from '@/components/commons/no-permission-box/NoPermissionBox'
import {PatientExtended} from '@/features/patients/types'
import {PatientDetailsMedicalRecord} from '../patient-details-medical-record/PatientDetailsMedicalRecord'

export const MedicalRecord = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const {patient} = useOutletContext<{patient: PatientExtended}>()
    const hasMedicalRecord = useMemo(() => patient.medicalRecord?.id, [patient.medicalRecord?.id])

    if (!permissions?.medicalRecords.read) {
        return <NoPermissionBox />
    }

    if (!hasMedicalRecord) {
        return <MedicalRecordEmptyState patient={patient} />
    }

    return (
        <>
            <Helmet title={t('patients:details_medical_records_meta_title', {fullName: patient.fullName})} />
            <PatientDetailsMedicalRecord />
        </>
    )
}
